import { debug } from '../../../core/js/utils/logger';
import { generate, generateDictionary } from '../utils/componentUtils';
import { mDom, mDomMaintainInputVals } from '../utils/renderUtils';
import { checkForm, shouldActivateParsley } from '../utils/errorHandling';
import {
    sendEmailSignUpData
} from '../actions/userActions';
import { fireGATrackingEvent } from '../../../core/js/utils/analyticsUtils';
import template from 'footer/sticky-email-signup.j2';
import { emailSignupSaga } from '../sagas/userSagas';
import { setEmailSignupStickyState } from '../actions/emailSignupActions';

function attachParsley(component, store) {
    debug('footer: attachParsleyForStickyEmailSignUp');

    $(component.scopedSelector('.js-sticky-email-signup-form')).parsley()
        .on('field:validated', (e) => {
            const [values, msgs] = checkForm(component.scopedSelector('.js-sticky-email-signup-form'));
            let previousMsgs = {};
            if (store.getState().core.footer.emailSignup) {
                previousMsgs = store.getState().core.footer.emailSignup.messages;
            }

            store.dispatch(sendEmailSignUpData(_.omitBy(values, _.isEmpty), msgs, previousMsgs, 'footer'));
        });
}

function afterConstruction(store) {
    if (shouldActivateParsley('.js-sticky-email-signup-form')) {
        attachParsley(this, store);
    }
}

function clearForm(store, component) {
    $('.js-sticky-email-signup-form')
        .find('input')
        .val('');
}

function handleHideSignUpOnScroll(store, currentScrollPosition) {
    const $domFooter = $('.dom-footer');

    if (!$domFooter.length) {
        return;
    }

    function unBindStickyState() {
        store.dispatch(setEmailSignupStickyState(false));
        $(window).off('scroll.stickyEmailScroll');
    }

    if ($('.js-mto-customize-fixed-item').hasClass('is-fixed')) {
        unBindStickyState();
    } else {
        const windowHeight = $(window).height();
        const stickyHeight = $('.js-sticky-email-signup-container').height();
        const footerPosition = $domFooter.offset().top - windowHeight + stickyHeight;

        if (currentScrollPosition >= footerPosition) {
            unBindStickyState();
        }
    }
}

/**
 * Attach component events to DOM
 * @param {Object} store Redux store
 * @returns {undefined}
 */
function attachEvents(store) {
    const $domFooter = $('.dom-footer');
    const $stickyContainer = $('.js-sticky-email-signup-container');

    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-sticky-email-signup-form'), (e) => {
        debug('#email-signup-form submit');
        e.preventDefault();

        const emailSignUpOverrides = {
            originatedFromOutsideAccount: true
        };

        this.attachLoader(store);
        const formData = {
            emailAddress: $(this.scopedSelector('[name="email"]')).val(),
            source: _.get(store.getState().core, 'footer.emailSignup.optInSource', 'Sticky Sign Up')
        };

        const thisComponent = Object.assign({}, this, emailSignUpOverrides);

        store.runSaga(emailSignupSaga, formData, e, thisComponent).done.then(() => {
            fireGATrackingEvent(store, 'email signup', 'signup complete');
            this.removeLoader(store);
            store.dispatch(setEmailSignupStickyState(false));
            clearForm(store, this);
        });
    });

    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-sticky-email-signup__close'), (e) => {
        store.dispatch(setEmailSignupStickyState(false));
        clearForm(store, this);
    });

    if ($domFooter.length && $stickyContainer.length) {
        $(window).on('scroll.stickyEmailScroll', _.debounce(() => {
            const currentScrollPosition = $(window).scrollTop();
            handleHideSignUpOnScroll(this.store, currentScrollPosition);
        }, 100));
    }

}

/**
 * Bootstrap the component onto the page
 * @param {Object} store Redux store
 * @param {Object} overrides Optional component overrides
 * @returns {Object} constructed components
 */
export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-footer .dom-sticky-email-signup',
        watch: ['core.footer.emailSignup', 'core.deviceCharacteristics'],
        name: 'stickyEmailSignUpComponent',
        attachEvents: attachEvents,
        template: template,
        generateDictonary: generateDictionary,
        afterConstruction: afterConstruction,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals,
        originatedFromOutsideAccount: false,
        storeRoot: 'footer'
    };

    return generate(config, store, overrides);
}
